window.showModal = function($modal, $modalUrl) {
    $($modal).find('.modal-content').load($modalUrl);
}


window.checkIfExists = ($item) => {
  const item = $($item).length;
  return (item > 0);
}
